<div class="fixed inset-0 bg-gray-700 bg-opacity-75 flex justify-center items-center no-scrollbar z-20">
    <div class="bg-white shadow-lg rounded p-4 max-w-md w-full relative">
        <h1 class="font-bold text-xl">{{title}}</h1>
        <p class="mt-1 text-primary-300 text-sm">{{description}}</p>
        <div class="w-full flex flex-col mt-1">
            <app-s3-document-upload #uploader [preSignedUrlEndpoint]="preSignedUrlEndpoint"
                [formats]="['.pdf', '.jpeg', '.jpg', '.png']" [apikey]="apiKey" [maxFileSize]="maxFileSize"
                [cloudFrontDomain]="cloudFrontDomain"></app-s3-document-upload>
        </div>

        <div class="mt-4 flex flex-row gap-4 justify-end">
            @let loading = (loading$ | async);
            <button type="button" (click)="onCancel()" [disabled]="loading"
                class="text-primary-500 px-4 py-2 focus:outline-none">Cancel</button>
            <button type="submit" (click)="submit()" [disabled]="loading || !uploader.getIsAttached()"
                class="bg-primary-500 disabled:bg-primary-100 disabled:text-primary-500 text-white rounded font-semibold px-4 py-2 focus:outline-none">{{action}}</button>
        </div>
    </div>